import { mockPlanA } from './mockPlanA'
import { mockPlanB } from './mockPlanB'
import { MOCK_PLAN_A_ID, MOCK_PLAN_B_ID } from './mockPlansConstants'
import { PlansReducer } from 'state/reducers/types/PlansReducer'

export const mockPlans: PlansReducer = {
  [MOCK_PLAN_A_ID]: mockPlanA,
  [MOCK_PLAN_B_ID]: mockPlanB,
}
